


import React from 'react';
import { Link  } from 'react-router-dom';


import step1 from '../../helpdesk/images/baza/del/step1.PNG';
import step2 from '../../helpdesk/images/baza/del/step2.PNG';
 


class DelBaza extends React.Component
 {



  render(){

    return(
        <>
        <section id="method" className="section border-no-sec">
          <h3>Krok 1</h3>
          <br/>
          <p>Aby usunąć firmę przechodzimy do menu "Baza firm" i wybieramy daną pozycję na liście.</p>

          <img src={step1} alt=""/>

        </section>
        <section id="method" className="section border-no-sec">

          <h3>Krok 2</h3>
          <br/>
          <p>W widoku szczegółowych informacji musimy poszukać czerwonego przycisku "przenieś do archiwum".</p>
          <div className="imp-note"><p>Uwaga! Tak jak wskazuje komunikat, firmy nie możemy przenieść do archiwum gdy: <br/><br/>
            *firma prowadzi szkolenia<br/>
            *firma prowadzi badania<br/>      
            *do firmy powiązani są pracownicy   
          
          </p></div>
          <p>Jeżeli pomimo tego chcemy zarchiwizować firmę, musimy najpierw usunąć szkolenia, badania i użytkowników z którymi / do których powiązana jest ta firma. <br/>
            Użytkowników możemy przenieść także do innej firmy jeśli chcemy aby dane użytkowników pozostały w systemie.
          </p>


          <img src={step2} alt=""/>

        </section>


        </>

    )
  }



}

export default DelBaza;